import { RouterView } from "vue-router";
import { dictRouting } from "./dict/dict.routing";

export const DataDictRouting = {
  path: "/data-dict",
  name: "data-dict",
  redirect: "/data-dict/dict/list",
  component: RouterView,
  meta: { title: "数据字典", icon: "setting" },
  children: [...dictRouting],
};
